import { Injectable } from '@angular/core';

import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  private URL_PREFIX = environment.apiCheckinData;
  constructor(private http:HttpClient) { }

  getLanguageByName(term: string){
    const url = `${this.URL_PREFIX}/languages?name=${term}`;
    return this.http.get(url);
  }

  getCountryByName(term: string) {
    const url = `${this.URL_PREFIX}/countries?name=${term}&lang=fr`;
    return this.http.get(url);
  }

  getCountries(){
    return this.http.get(this.URL_PREFIX+'/countries');
  }
}
